module.exports = __webpack_public_path__ + "img/thumbnail_Cheetah_f_normal.19701486.png";